import { useState, format, PageStyle, ChevronLeftRed, ChevronRightRed, CalendarAction, useEffect, useRouter, React, CommonAction } from '@/imports-files/components/calendar/calendar';

function CalendarDate(props)
{
    const router = useRouter();
    const commonAction = new CommonAction();
    const [currentDate, setCurrentDate] = useState( commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
    const calendarHash = {'current_date': (commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date()), 'is_my_interviews': commonAction.getParamsToUrlWithoutRouter('is_my_interviews')||true, 'selected_tab':'day'};
    const calendarAction = new CalendarAction(props.setCalendarData, calendarHash, router, props.setCalendarDataArray);

    useEffect(()=>{
                     setCurrentDate(commonAction.getParamsToUrlWithoutRouter('current_date') ? new Date(commonAction.getParamsToUrlWithoutRouter('current_date').split('/').reverse().join('/')) : new Date());
                     calendarAction.getCalanderData(calendarHash);
                  }, [props.calandarFlagForRerender])


    const renderCurrentDate = ()=> {
        const dateFormat = "dd MMMM yyyy, EEEE";
        let ddmmYYDate = commonAction.getDateInDMYFormat(currentDate)
        return (
            <div className={`${PageStyle.CalendarDate}`}>
                <div className={`${PageStyle.CalendarDate__LeftIcon}`}>
                    <div className="icon" onClick={()=> calendarAction.changeDateHandle("prev", currentDate, setCurrentDate, props.setTodayClick)}>
                    <span className="chevron-left"><ChevronLeftRed/></span>
                    </div>
                </div>
                <div className={`${PageStyle.CalendarDate__Content} ${PageStyle.CalendarDate__CenterFlex}`}>
                    <span className={`${PageStyle.CalendarDate__Content__CurrentDate}`}>
                    {format(currentDate, dateFormat)}</span>
                    <span className={`p-relative ${calendarAction.greenDotClass(ddmmYYDate, props.calendarDataArray, PageStyle.CalendarDate__Content__InterviewAvailable)}`}></span>
                </div>
                <div className={`${PageStyle.CalendarDate__RightIcon}`}>
                 <div className="icon" onClick={() => calendarAction.changeDateHandle("next", currentDate, setCurrentDate, props.setTodayClick)}>
                 <span className="chevron-right"><ChevronRightRed/></span>
                 </div>
                </div>
            </div>
        );
    }


    return (
        <div className={`${PageStyle.DateFNS__Calendar}`}>
             <div className={`${PageStyle.DateFNS__Calendar__Date}`}>
                {renderCurrentDate()}
            </div>
        </div>
    );
}

export default React.memo(CalendarDate)
